export default {
  'projectDetail.label.lookDetailButton': 'Look Detail',
};
